// import {FC} from 'react'
// import {calculateAgeFromDOB} from '../../../../../../../../data/config'

// const AgeCell = (props: any) => {
//   const {years, months, days} = calculateAgeFromDOB(props?.tableProps?.dob)

//   return (
//     <div className='d-flex ms-5 '>
//       <span className='text-black fw-bold fs-7 '>
//         {props?.tableProps?.dob ? (
//           <>
//             {years > 0 ? `${years}Y` : ''}
//             {months > 0 ? ` ${months}M` : ''}
//             {days > 0 ? ` ${days}D` : ''}
//           </>
//         ) : (
//           'N/A'
//         )}
//       </span>
//     </div>
//   )
// }

// export {AgeCell}

/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {MenuComponent} from '../../../../../../../../_ePulse/assets/ts/components'
import {KTSVG} from '../../../../../../../../_ePulse/helpers'
import {Link, useNavigate} from 'react-router-dom'

import {checkPermission} from '../../../../../../../App'
import useLocalStorageFetch from '../../../../../../../../hooks/localStorageFetch'
import {useDispatch} from 'react-redux'
import {actionsUsers} from '../../../../../../../../setup/redux/rootReducer'
import {calculateAgeFromDOB} from '../../../../../../../../data/config'

const AgeCell = (props: any) => {
  const appointment = props.tableProps
  const {years, months, days} = calculateAgeFromDOB(props?.tableProps?.dob)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const {role} = useLocalStorageFetch()

  const onHandleclick = (appointment: any) => {
    // navigate(`/${role}/rx_template/rx-on-fly`, {
    //   state: {
    //     appointmentId: appointment.id,
    //     patientData: {
    //       userId: appointment.patientId,
    //       firstName: appointment.firstName,
    //       lastName: appointment.lastName,
    //     },
    //   },
    // })

    //New user flow
    navigate(`/${role}/patient-details`, {
      state: {
        appointmentId: appointment.id,
        patientData: {
          userId: appointment.patientId,
          firstName: appointment.firstName,
          lastName: appointment.lastName,
          profilePhoto: appointment.profilePhoto,
          dob: appointment.dob,
          mobileNumber: appointment.mobileNumber,
          age: appointment?.age,
        },
      },
    })
  }

  return (
    <div className='d-flex ms-5'>
      <div className='d-flex flex-row col '>
        <div className='d-flex flex-row align-items-center '>
          {!appointment.isPrescriptionSent ? (
            checkPermission('storeClinicRxPrescriptionData') && (
              <button
                onClick={() => {
                  dispatch(actionsUsers.updateSelectedPatient({}))
                  onHandleclick(appointment)
                  localStorage.setItem('todayRXEdit', 'NO')
                }}
                className='menu-link text-dark border-0 bg-white '
              >
                <span className='text-black fw-bold fs-7 '>
                  {props?.tableProps?.age
                    ? props?.tableProps?.age
                    : // <>
                      //   {years > 0 ? `${years}Y` : ''}
                      //   {months > 0 ? ` ${months}M` : ''}
                      //   {days > 0 ? ` ${days}D` : ''}
                      // </>
                      'N/A'}
                </span>
              </button>
            )
          ) : (
            <span className='text-black fw-bold fs-7 '>
              {props?.tableProps?.age
                ? // <>
                  //   {years > 0 ? `${years}Y` : ''}
                  //   {months > 0 ? ` ${months}M` : ''}
                  //   {days > 0 ? ` ${days}D` : ''}
                  // </>
                  props?.tableProps?.age
                : 'N/A'}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}

export {AgeCell}
